import {AbstractControl, ValidationErrors, ValidatorFn} from "@angular/forms";
import {formatDate} from "@angular/common";

export function dateRegexValidator(validation: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if(!control.value){
            return null;
        }

        const formattedDate = formatDate(control.value, 'MM/dd/yyyy', 'en-US');

        const isValid = new RegExp(validation).test(formattedDate);
        return isValid ? null : {'datePatternInvalid': true};
    }
}